@if (breakpoint.mdAndLarger()) {
  @for (guide of guides(); track guide?.uuid || $index) {
    @if (guide) {
      <!-- Duplicate hydration rendering fix: https://github.com/angular/angular/issues/50543#issuecomment-1573339782 -->
      <ng-content /><ng-container
        [ngTemplateOutlet]="content"
        [ngTemplateOutletContext]="{ guide: guide }"
      ></ng-container>
    }
  }
} @else {
  <div>
    <mobi-ui-carousel-major
      [infinite]="true"
      class="block view-enter-animation [&_.items-wrapper]:!pt-2"
    >
      @for (guide of guides(); track guide.uuid) {
        <div>
          <!-- Duplicate hydration rendering fix: https://github.com/angular/angular/issues/50543#issuecomment-1573339782 -->
          <ng-content /><ng-container
            [ngTemplateOutlet]="content"
            [ngTemplateOutletContext]="{ guide: guide, index: $index }"
          ></ng-container>
        </div>
      }
    </mobi-ui-carousel-major>
  </div>
}

<ng-template #content let-guide="guide" let-index="index">
  <a
    [betterRouterLink]="guide.url | extractUrl"
    class="mobi-ui-grid smMax:!gap-y-2 view-enter-animation mobi-ui-animation-trigger-hover group"
  >
    @if (guide.teaserImage) {
      <div class="mobi-ui-col-1/1 md:mobi-ui-col-1/2 mobi-ui-margin-y-sm">
        <div class="rounded-md overflow-hidden">
          <mobi-media
            class="block mobi-ui-animation-scale-up-init mobi-ui-animation-scale-up-hover-target"
            [entity]="guide.teaserImage"
            responsiveStyle="teaser"
            [lazy]="index !== 0"
          ></mobi-media>
        </div>
      </div>
    }
    <div class="text-black mobi-ui-col-1/1 md:mobi-ui-col-1/2 mobi-ui-margin-y-sm">
      <h4
        class="mobi-ui-text-inked mobi-ui-padding-t-xs md:!pt-0 mobi-ui-font-h5 guide-title-sm-max"
      >
        {{ guide.teaserTitle }}
      </h4>
      @if (guide.teaserText) {
        <mobi-text
          class="text-read group-hover:text-signature transition-colors mobi-ui-font-size-200 guide-text-sm-max"
          [data]="guide.teaserText | stripHtml: [] : true"
        />
      }
      <div class="flex items-center gap-x-[18px] mobi-ui-margin-t-md smMax:!mt-5">
        @if (guide?.upvotes > 0) {
          <mobi-rating-counter [count]="guide.upvotes" />
        }
        <mobi-is-new [date]="guide.created" />
      </div>
    </div>
  </a>
</ng-template>
